import Vue from 'vue'
import VueRouter from 'vue-router'
import MonitoringView from '../views/MonitoringView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Monitoring',
    component: MonitoringView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router